import { Inject, Injectable, Optional } from "@angular/core"
import { Response } from 'express'
@Injectable({
    providedIn: 'root'
})
export class ServerSideResponseService {
  
    constructor( @Optional() @Inject(Response) private response: Response) {
      this.response = response 
    }
  
    setNotFound(message = 'not found'): this {
      if (this.response) {
        this.response.statusCode = 302;
        this.response.statusMessage = message
      }
      return this
    }

    setStatusCode(statusCode:any)
    {
      if (this.response) {
        this.response.status(statusCode);
      }
      return this
    }
  }